<div class="row top-content-row">
  <div class="col-md-12 form-inline" style="margin: 0px 12px">
    <h1 class="heading">Adaptive Rules
      <user-search></user-search>
      <img *ngIf="loading$ | async" src="img/loading.gif"/>
      <img *ngIf="deleteLoading" src="img/loading.gif"/>
    </h1>
  </div>

  <div *ngIf="viewModel$ | async as viewModel">
    <div *ngIf="canAccessAdaptive">
    <div class="sideBtnPanel">
      <button class="btn btn-primary"
              name="save-btn"
              [ngClass]="{'btn-right-open': isUpdated}"
              [disabled]="!isUpdated || viewModel.selectedUser === undefined"
              (click)="saveRule(viewModel.selectedUser.userId)"><i class="glyphicon glyphicon-ok"></i> &nbsp;Save Changes
      </button>

      <button class="btn btn-primary"
              name="save-btn"
              [ngClass]="{'btn-right-open': isUpdated}"
              [disabled]="viewModel.selectedUser === undefined || isNewRule || selectedRule === undefined || deleteLoading"
              (click)="deleteRule(viewModel.selectedUser.userId)"><i class="glyphicon glyphicon-ok"></i> &nbsp;Delete Rule
      </button>

    </div>
    <div class="modal-body row adaptive-rules-mapper">
      <div class="col-md-12 clearfloat" style="width:99%; padding-bottom: 12px; min-height: 300px">

        <span *ngIf="viewModel.selectedUser !== undefined && viewModel.selectedUser.userId !== 0" style="margin: 0px 12px">User: {{ viewModel.selectedUser.userName}} (ID: {{viewModel.selectedUser.userId}}) </span>
        <div class="form-horizontal form-top">
          <rule-controls [loading]="viewModel.loading"
                         (ruleChanged)="updateRule($event, viewModel.userRules)"
                         (addedNew)="isNew($event)"
                         [userRules]="userRules$ | async"
                         (selectRuleChanged)="selectRule($event, viewModel.selectedUser.userId)"
                         [selectedUserId]="viewModel.selectedUser.userId"
                         *ngIf="viewModel.selectedUser !== undefined && viewModel.selectedUser.userId !== 0"
          ></rule-controls>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>